module.exports = __webpack_public_path__ + "static/img/yule_music.22b847ff.png";